import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { masterSupabase } from '../lib/supabase-master';

export function useProperties() {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    if (!user) return;

    setLoading(true);
    setError(null);

    const { data, error } = await masterSupabase
      .from('properties')
      .select('id, property_name, street, city')
      .eq('created_by', user.id)
      .order('property_name', { ascending: true });

    if (error) {
      console.error('[useProperties] Error:', error);
      setError(error);
      setProperties([]);
    } else {
      console.log('[useProperties] Loaded:', data?.length);
      setProperties(data || []);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!user) {
      setProperties([]);
      setLoading(false);
      return;
    }

    load();
  }, [user]);

  return { properties, loading, error, refetch: load };
}
